<template>
  <el-dialog
    title="选择已有合同"
    :visible="visible"
    :before-close="handleCloseDialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :append-to-body="true"
    width="800px"
  >
    <div style="margin-bottom: 20px;">一次仅可关联一个合同。</div>
    <div class="search-cover">
      <el-input :placeholder="keyWordHolder[keyWord]" v-model="keyWordValue"
                :maxlength="50"
                style="width: 400px;"
                clearable
      >
        <el-select v-model="keyWord" slot="prepend" placeholder="请选择" class="select-in-input">
          <el-option label="合同编号" value="contractNo"></el-option>
          <el-option label="合同流程编号" value="requestNo"></el-option>
          <el-option label="客户名称" value="customerName"></el-option>
        </el-select>
      </el-input>
      <el-button size="small" style="margin-left: 30px;" type="primary" @click="handleFind"> 查找</el-button>
    </div>
    <template v-if="isSearch">
      <el-table v-loading="tableLoading"
                @selection-change="handleSelectionChange"
                @select="select"
                @select-all="selectAll"
                :empty-text="emptyText"
                ref="multipleTable"
                :data="tableData">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="htbh1" label="合同编号" align="center" />
        <el-table-column prop="htbh" label="合同流程编号" align="center" />
        <el-table-column prop="dfgsmc" label="客户名称" align="center" />
      </el-table>
      <el-pagination
        style="text-align: right; margin-top: 20px"
        :current-page="page.pageNumber"
        :page-size="page.pageSize"
        layout="total, sizes, prev, pager, next"
        :page-sizes="[5, 10, 20]"
        :total="total"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      >
      </el-pagination>
      <div style="text-align: center; margin-top: 10px;">
        <el-button style="margin-right: 20px;" @click="handleCloseDialog">关 闭</el-button>
        <el-button type="primary" @click="beforeSubmit" v-loading="loading">确 定</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import service from "@/services/api/business";
import { mapGetters } from "vuex";

export default {
  props: {
    detailId: {
      type: String,
    },
    businessId: {
      type: String,
    },
    isCustom: {
      type: Boolean,
    },
    customName: {
      type: String,
    },
    customId: {
      type: String,
    },
  },
  computed: {
    ...mapGetters({
      busiOpportunityDetail: "business/busiOpportunityDetail",
    }),
  },
  data() {
    return {
      visible: false,
      keyWord: 'contractNo',
      keyWordValue: '',
      keyWordHolder: {
        1: '请输入合同编号',
        2: '请输入合同流程编号',
        3: '请输入客户名称',
      },
      emptyText: '没有查到您要的数据，请检查后重新操作',
      formData: {
      },
      tableData: [],
      tableLoading: false,
      pageSize: 10,
      pageNumber: 1,
      page: {
        pageNumber: 1,
        pageSize: 10,
      },
      total: 0,
      multipleSelection: [],
      isSearch: false,
      loading: false,
    }
  },
  methods: {
    open() {
      this.visible = true
      this.initData()
    },
    initData() {
      this.formData = {
      }
      // this.handleFind()
    },
    handleCloseDialog() {
      this.visible = false
    },
    handleCancel() {
      this.handleCloseDialog()
    },
    handleCurrentChange(value) {
      this.pageNumber = value
      this.handleFind()
    },
    handleSizeChange(value) {
      this.pageNumber = 1
      this.pageSize = value
      this.handleFind()
    },
    async handleFind() {
      try {
        this.isSearch = true
        const param = {
          pageSize: this.pageSize,
          pageNumber: this.pageNumber,
          [this.keyWord]: this.keyWordValue,
        }
        this.tableLoading = true
        const apiService = this.isCustom ? service.customerContractList : service.contractList
        const { data } = await apiService(param)
        this.tableData = data.results
        this.total = data.totalCount
        this.tableLoading = false
      } catch (e) {
        console.log(e)
        this.tableLoading = false
      }
    },
    handleSelectionChange(value) {
      if (value.length > 1) {
        this.$message({
          type: 'warning',
          message: '一次仅可关联一个合同!',
        });
        return
      }
      this.multipleSelection = value;
    },
    // 只能勾选1个主机
    select(selection) {
      if (selection.length > 1) {
        this.$refs.multipleTable.toggleRowSelection(selection.shift(), false)
        this.$message({
          type: 'warning',
          message: '一次仅可关联一个合同!',
        });
      }
    },
    selectAll(selection) {
      if (selection.length > 1) {
        selection.length = 1
      }
    },
    beforeSubmit() {
      if (!this.multipleSelection.length) {
        this.$message({
          message: '请选择要添加的合同！',
          type: 'warning',
        })
        return
      }
      if (this.isCustom) {
        // eslint-disable-next-line no-empty
        if (this.customName !== this.multipleSelection[0].dfgsmc) {
          this.$confirm('将要关联合同的签约主体与当前客户不一致，是否继续关联？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(() => {
            this.handleSubmit(this.customId)
          }).catch(() => {
          });
          // eslint-disable-next-line no-empty
        } else {
          this.handleSubmit(this.customId)
        }
      } else {
        // eslint-disable-next-line no-empty,no-lonely-if
        if (this.busiOpportunityDetail.customerName !== this.multipleSelection[0].dfgsmc) {
          this.$confirm('将要关联合同的签约主体与当前商机对应的客户不一致，是否继续关联？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(() => {
            this.handleSubmit(this.busiOpportunityDetail.customerId)
          }).catch(() => {
          });
          // eslint-disable-next-line no-empty
        } else {
          this.handleSubmit(this.busiOpportunityDetail.customerId)
        }
      }
    },
    async handleSubmit(customerName) {
      try {
        const row = this.multipleSelection[0]
        const apiService = this.isCustom ? service.customerRelateContract : service.relateContract
        console.log(this.busiOpportunityDetail.customerName, row.dfgsmc)
        const {
          htbh1, htlx, htgdrq, cpx, qyxs, hzms, dfgsmc, htjsfs, htjexx, htsxr, htzzr, bz, htmc, jsbl, wfqyzt, htbh, ztzzlx, sqr, sqrq, htsmjzc, modifier, modifiedate, dyhtlc,
          ywyloginid, qsxs,
        } = row
        const param = {
          contractNo: htbh1, // 合同编号
          contractType: htlx, // 合同类型
          signDate: htgdrq, // 合同签订时间
          businessLineList: cpx ? cpx.split(',') : [], // 产品线，产品线id
          signingForm: qyxs, // 签约形式
          coopMode: hzms, // 合作模式
          customerId: customerName, // 客户
          businessId: this.businessId || this.detailId, // 商机id
          settlementType: htjsfs, // 结算方式
          contractAmountStr: htjexx, // 合同金额
          startDate: htsxr, // 合同开始时间
          endDate: htzzr, // 合同结束时间
          remarks: bz, // 备注
          salesmanCode: ywyloginid, // 业务员loginId
          contractName: htmc, // 合同名称
          settlementScale: jsbl, // 结算比例
          myContractConfirmation: wfqyzt, // 我方签约主体
          contractRequestNo: htbh, // 合同审批流水号
          contractDeadline: ztzzlx, // 合同期限
          creator: sqr, // 申请人loginId
          createDate: sqrq, // 申请日期
          fileIds: htsmjzc, // 附件ids
          modifier, // 更新者loginId
          modifierDate: modifiedate, // 更新时间
          requestId: dyhtlc, // 合同流程id
          acceptType: qsxs,
        }
        this.loading = true
        const { data } = await apiService(param)
        console.log(data)
        this.$message({
          type: 'success',
          message: '关联成功!',
        });
        this.keyWord = 'contractNo'
        this.keyWordValue = ''
        this.multipleSelection = []
        this.isSearch = false
        this.visible = false
        this.$emit('success')
        this.loading = false
      } catch (e) {
        console.log(e)
        this.loading = false
      }
    },
  },
}
</script>

<style lang="css" scoped>
  .search-cover {
    display: flex;
    margin-bottom: 20px;
  }
</style>
